import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faRedo} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

const TimesUp = ({correct}) => {
    return ( 
        <div className="times-up">
            <h1>{correct}</h1>
            <h2> Times Up!!	</h2>
          <Link to = "/window">
          <div className = "redo" > <FontAwesomeIcon  icon ={ faRedo}/></div>
          </Link>
        </div>
     );
}

export default TimesUp;